export type TDocumentOwner = {
  LEGAL_ONBOARDING_APPROVER: number;
  CREDIT_ONBOARDING_APPROVER: number;
};

export const documentOwner: TDocumentOwner = {
  LEGAL_ONBOARDING_APPROVER: 1,
  CREDIT_ONBOARDING_APPROVER: 2,
};
